"use client";

import { Card, CardContent, CardFooter } from "@heroui/react";
import { CameraIcon, Star, Stars } from "lucide-react";
import Link from "next/link";

import { Path } from "../types/path";

import PathAvatarGroup from "./path-avatar-group";

export default function PathCard({ path }: { path: Path }) {
  return (
    <Link
      className="col-span-12 block sm:col-span-4"
      href={`/paths/${encodeURIComponent(path.id)}`}
    >
      <Card className="group relative h-50 overflow-hidden bg-[url('/img/card-2.svg')] bg-cover bg-center shadow-none transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-xl dark:bg-[url('/img/card-2-dark.png')] p-5">
        <div className="absolute inset-0  transition-colors duration-300 group-hover:bg-black/25" />
        <CardContent className="flex-col items-start! text-justify transition-transform duration-300 group-hover:-translate-y-0.5">
          <p className="text-primary-700 line-clamp-2 text-lg font-bold uppercase dark:text-white">
            {path.title}
          </p>
          <p className="text-muted line-clamp-3 pt-2 text-sm">{path.details}</p>
        </CardContent>
        <CardFooter className="absolute bottom-0 z-10 gap-3 transition-transform duration-300 group-hover:-translate-y-0.5 pb-3">
          <div className="flex gap-2 items-center">
            <span className="text-sm font-semibold">20</span>
            <PathAvatarGroup avatars={["", ""]} />
            
          </div>
          <div className="flex gap-2 items-center">
            <span>
              <Star fill="" size="16" />
            </span>
            <span>4.4</span>
          </div>
          <p className="text-sm font-semibold">Hours 20</p>
          <p className="text-sm font-semibold">Courses 4</p>
        </CardFooter>
      </Card>
    </Link>
  );
}
